import { Dayjs } from "dayjs";
import { api } from "../../../config/api";
import { OrderFormType } from "./AddOrder";
import { useQuery } from "@tanstack/react-query";
import { OrderRowType } from "./OrderData";

export const fetchAllOrder = (
  startDate: Dayjs,
  endDate: Dayjs,
  page: number,
  shipment: string,
  status?: string
) => {
  const fromDate = startDate.format("YYYY-MM-DD");
  const toDate = endDate.format("YYYY-MM-DD");

  return api.get(`/b2c/orders/`, {
    params: {
      from_date: fromDate,
      to_date: toDate,
      page: page,
      page_size: 50,
      shipment: shipment,
      status: status || "",
    },
  });
};

export const bulkOrderUpload = (file: File | null) => {
  return api.post(
    "/b2c/csv_order_create/",
    { file: file },
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

export const storeOrder = (data: OrderFormType) => {
  return api.post("/b2c/create_order/", data);
};

export const fetchRateRequest = (id: any) => {
  return api.get("/b2c/request_rate/", {
    params: {
      id: id,
    },
  });
};

export const assignOrder = ({
  id,
  quote_id,
}: {
  id: number | string;
  quote_id: number | string;
}) => {
  return api.post("/b2c/assign_shipment/", {
    id,
    quote_id,
  });
};

export const bookOrderMethod = (arrayOfOrderId: string[]) => {
  return api.post("/b2c/book_shipment/", arrayOfOrderId);
};
export const addOrderTagMethod = ({
  id,
  tag,
}: {
  id: number | string;
  tag: string;
}) => {
  return api.post("/b2c/order_tag/", {
    id,
    tag,
  });
};

interface scheduleDate {
  id: string | number;
  pickup_date: string;
}

export const scheduleOrder = (data: scheduleDate[]) => {
  return api.post("/b2c/schedule_pickup/", data);
};

export const getOrderDetails = (id: string) => {
  return api.get("b2c/shipment_details/", {
    params: {
      id,
    },
  });
};

export const cancelShipment = (data: string[]) => {
  return api.post("/b2c/cancel_shipment/", data);
};
export const cancelOrder = (data: string[]) => {
  return api.post("/b2c/cancel_order/", data);
};

export const downloadAwb = (id: any) => {
  return api.get("/b2c/download_awb/", {
    params: {
      id,
    },
    responseType: "blob",
  });
};
export const bulkdownloadAwb = (data: any) => {
  console.log("data",data);
  return api.post(
    "/b2c/bulk_print/",
    {
      doc_type: "label",
      shipment_ids: data.shipment_ids || [],
    },
    {
      responseType: "blob",
    }
  );
};



export const downloadProForma = (id: any) => {
  return api.get("b2c/pro_forma_invoice/", {
    params: {
      id,
    },
    responseType: "blob",
  });
};

export const assignMultipleService = ({
  id,
  service,
  mode,
}: {
  id: string;
  service: string;
  mode: string;
}) => {
  return api.post("b2c/csv/vendor_service/", {
    id,
    service,
    mode,
  });
};

export const trackOrder = (id: string) => {
  return api.get("/b2c/track_shipment/", {
    params: {
      id,
    },
  });
};
export const trackOrderAwb = (awbNo: string) => {
  return api.get(`/b2c/track_shipment/?awbNo=${awbNo}`, {
    
  });
};

export const trackOrderAwbNo = (awbNo: string) => {
  return api.get(`/b2c/shipment_tracking/?awbNo=${awbNo}`, {
    
  });
};
// export function useOrders(
//   startDate: Dayjs,
//   endDate: Dayjs,
//   page: number,
//   shipment: string,
//   status?: string
// ) {
//   const { isLoading, data, error } = useQuery({
//     queryKey: [
//       "orders",
//       startDate.format("YYYY-MM-DD"),
//       endDate.format("YYYY-MM-DD"),
//       page,
//       shipment,
//       status,
//     ],
//     queryFn: () => fetchAllOrder(startDate, endDate, page, shipment, status),
//   });

//   const orders = (data?.data?.data?.data as OrderRowType[]) ?? [];
//   const totalRows = data?.data?.data?.pages_count ?? 0;

//   return { isLoading, error, orders, totalRows };
// }
